import { api } from './authService';

export const retryStrategyService = {
  // CRUD operations
  getStrategies: async (params = {}) => {
    try {
      const response = await api.get('/acs/retry-strategies/', { params });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch retry strategies: ${error.message}`);
    }
  },

  getStrategy: async (id) => {
    try {
      const response = await api.get(`/acs/retry-strategies/${id}/`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch retry strategy: ${error.message}`);
    }
  },

  createStrategy: async (data) => {
    try {
      const response = await api.post('/acs/retry-strategies/', data);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to create retry strategy: ${error.message}`);
    }
  },

  updateStrategy: async (id, data) => {
    try {
      const response = await api.put(`/acs/retry-strategies/${id}/`, data);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to update retry strategy: ${error.message}`);
    }
  },

  deleteStrategy: async (id) => {
    try {
      await api.delete(`/acs/retry-strategies/${id}/`);
      return true;
    } catch (error) {
      throw new Error(`Failed to delete retry strategy: ${error.message}`);
    }
  },

  // Special operations
  getDefault: async () => {
    try {
      const response = await api.get('/acs/retry-strategies/default/');
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch default retry strategy: ${error.message}`);
    }
  },

  duplicateStrategy: async (id) => {
    try {
      const response = await api.post(`/acs/retry-strategies/${id}/duplicate/`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to duplicate retry strategy: ${error.message}`);
    }
  },

  toggleActive: async (id) => {
    try {
      const response = await api.post(`/acs/retry-strategies/${id}/toggle_active/`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to toggle retry strategy active status: ${error.message}`);
    }
  },

  // Utility functions
  validateStrategy: async (data) => {
    try {
      const response = await api.post('/acs/retry-strategies/validate/', data);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to validate retry strategy: ${error.message}`);
    }
  },

  // Message retry operations
  markMessageForRetry: async (messageId) => {
    try {
      const response = await api.post(`/acs/bulk-messages/${messageId}/mark_for_retry/`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to mark message for retry: ${error.message}`);
    }
  },

  getRetryCandidates: async (params = {}) => {
    try {
      const response = await api.get('/acs/bulk-messages/retry_candidates/', { params });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch retry candidates: ${error.message}`);
    }
  }
};

export default retryStrategyService; 